import { useState } from 'react'

import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import { Log, LogUnfinishedMetadata } from '@/types/logs'
import { TextArea } from '@/ui/TextArea'
import { useFlagLogUnfinished } from '../../../api/useFlagLogUnfinished'
import { useFlagRecordReopen } from '@/pages/Flagged/api/useFlagRecordReopen'

import styles from './FlagUnfinishedModal.module.scss'

export type Props = {
    logId: string
    metadata: LogUnfinishedMetadata | null
}

const MAX_COMMENT_LENGTH = 200

export const FlagLogUnfinishedModal = () => {
    const [comment, setComment] = useState('')
    const { closeModal, props } = useModal<Props>()

    const isReopen = props !== null && props?.metadata !== null && props?.metadata?.flag === false

    const { handleFlagLogUnfinished, isPending: flagPending } = useFlagLogUnfinished(
        props ? ({ id: props.logId, unfinishedFlagMetadata: props.metadata } as Log) : undefined
    )
    const { mutate: reopen, isPending: reopenPending } = useFlagRecordReopen()

    if (!props) return null

    const isPending = isReopen ? reopenPending : flagPending

    const handleSubmit = () => {
        if (isReopen) {
            reopen({ logId: props.logId, comment: comment || undefined }, { onError: () => closeModal() })
        } else {
            handleFlagLogUnfinished(comment)
        }
    }

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.container}>
                <div className={styles.information}>
                    <h1 className={styles.title}>Add flag</h1>
                    <p className={styles.description}>
                        This item will be flagged for a Performance Manager to review. You will be notified when it is
                        updated.
                    </p>
                </div>
                <div className={styles.edit}>
                    <p className={styles.hint}>Explain what further information you need</p>
                    <TextArea
                        value={comment}
                        counter
                        maxLength={MAX_COMMENT_LENGTH}
                        className={styles.editor}
                        onChange={(event) => setComment(event.target.value)}
                    />
                </div>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={closeModal}>
                    Cancel
                </Button>
                <Button
                    rounded
                    variant="secondary"
                    disabled={(!isReopen && !comment) || isPending}
                    onClick={handleSubmit}
                >
                    Flag unfinished
                </Button>
            </div>
        </Modal>
    )
}
